<template>
  <div class="oms-menu" :style="cssVars">
    <div class="oms-menu-header" :style="{ background: logoUi.navigationBackColor}">
      <span v-if="!collapsed">
        <img
          class="logo"
          :src="logoUi.menuSrc[0].src || ''"
          style="margin: 0px 10px 0px 0px; height: 26px "
          alt=""
        />
        <span style="color: white" v-if="!collapsed">{{ logoUi.menuTest || "" }}</span>
      </span>
      <img
        class="logo"
        v-else
        :src="logoUi.menuSrc[1].src || ''"
        style="margin: 10px; height: 26px "
        alt=""
      />
    </div>
    <div class="oms-menu-content" :style="{ background: logoUi.navigationBackColor}">
      <a-button v-if="cmhubError" type="link" @click="loadFusionMenu(true)">菜单加载失败，点击重试</a-button>
      <a-menu
        :class="{ 'cmhub-menu-tree': cmhub }"
      :style="{ background: logoUi.navigationBackColor, width: '100%'}"
        mode="inline"
        theme="dark"
        :inline-collapsed="collapsed"
        :selectedKeys="selectedKey"
        :open-keys="openKeys"
        @click="handleClick"
        @openChange="openChange"
      >
        <CmhubMenuNodes v-if="cmhub" :nodes="menuList" />
        <template v-for="item in (cmhub ? [] : menuList)">
          <a-sub-menu
            v-if="item.children && item.children.length"
            :key="item.menuCode"
            :class="{ 'oms-top-collapsed-selected': collapsed && selectedTopCode === item.menuCode }"
          >
           <div slot="title">
                    <div style="text-align: center">
                      <div class="iconBg" :class="{ collapsedIconBg: !collapsed }">
                        <IconFont v-if="areIcon(item.icon || '')" :type="item.icon" />
                        <a-icon v-else :type="item.icon" />
                        <span>{{ item.menuName }}</span>
                      </div>
                </div>
             </div> 
            <template v-for="(subItem) in item.children"> 
                <a-sub-menu v-if="subItem.children && subItem.children.length" class="two-menu" :key="subItem.menuCode" style="padding-left:22px;">
                    <div slot="title">
                    <div style="text-align: center">
                      <div class="iconBg" :class="{ collapsedIconBg: !collapsed }">
                        <IconFont v-if="areIcon(subItem.icon || '')" :type="subItem.icon" />
                        <a-icon v-else :type="subItem.icon" />
                        <span>{{ subItem.menuName }}</span>
                      </div>
                    </div>
                  </div> 
                  <a-menu-item
                    class="ant-menu-item"
                    style="padding-left:45px;"
                    v-for="ssubItem in subItem.children"
                    :key="ssubItem.menuCode"
                  >
                    {{ ssubItem.menuName }}
                  </a-menu-item>               
               </a-sub-menu>
               <a-menu-item v-else :key="subItem.menuCode" style="padding-left:22px;">
                  <IconFont v-if="areIcon(subItem.icon) || ''" :type="subItem.icon" />
                  <a-icon v-else :type="subItem.icon" />
                  <span>{{ subItem.menuName }}</span>
              </a-menu-item>
            </template>
          </a-sub-menu>
          <a-menu-item v-else :key="item.menuCode">
            <IconFont v-if="areIcon(item.icon) || ''" :type="item.icon" />
            <a-icon v-else :type="item.icon" />
            <span>{{ item.menuName }}</span>
          </a-menu-item>
        </template>
      </a-menu>
    </div>
    <div
      @click="menuSwitchOnClick"
      class="menu-switch"
      :class="{ menuUnfold: !collapsed, menuFold: collapsed }"
    >
      <a-icon
        class="menu-switch-icon"
        :type="collapsed ? 'menu-unfold' : 'menu-fold'"
      />
    </div>
  </div>
</template>

<script>
import { message, Icon } from 'ant-design-vue';
import { post, http } from '@/utils/http';
import api from '@/api';
import { getLogo } from '@/utils/intConfiguration';
import { isCustomerSaasPrivate } from '@/utils/globalConfig';
// eslint-disable-next-line import/no-duplicates
import mainBus from '@/micro/eventBus';
import { pointTools, pointMenus } from '@/utils/point';
import PermissionsTranslation from '../utils/permissions';
// eslint-disable-next-line import/extensions
import iconfrontjs from '../assets/iconfont/iconfont.js';
import { toClearCacheNoReload, Cookies, getSubAppHomeMenu } from '@/utils/utils';
import {aliyunDot} from '@/utils/point';
import { withSide, SIDE_QUERY } from '@/features/cmhub/navigation';
import { isCmhub } from '@/features/cmhub/config';
import { loadCmhubResources } from '@/features/cmhub/resources';
import CmhubMenuNodes from '@/features/cmhub/components/CmhubMenuNodes';

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: iconfrontjs,
});
// eslint-disable-next-line camelcase
export default {
  name: 'OmsMenu',
  components: {
    CmhubMenuNodes,
    IconFont,
  },
  data() {
    return {
      logoUi: getLogo(),
      selectedKey: [],
      openKeys: [],
      menuList: [],
      cmhubError: false,
      cmhub: isCmhub(),
      collapsed: false,
      openKey: '',
      selectedTopCode: '', // 当前页所属的一级菜单 code，用于收起态高亮一级图标
    };
  },
  computed: {
    cssVars() {
      return {
        "--navigationBackColor": this.logoUi.navigationBackColor,
        "--themeColor": this.logoUi.themeColor,
        "--navigationFoldColor": this.logoUi.navigationFoldColor,
        // 菜单默认文字色、子菜单背景色、菜单项间距/圆角（带设计图默认值，可由配置覆盖）
        "--navigationTextColor": this.logoUi.navigationTextColor || '#A5B2D4',
        "--navigationSubBackColor": this.logoUi.navigationSubBackColor || '#2B3C62',
        "--menuItemGap": this.logoUi.menuItemGap || '5px',
        "--menuItemRadius": this.logoUi.menuItemRadius || '8px',
      };
    },
  },
  watch: {
    // 监听 fullPath 而非 path：低码页面可能共用 path 仅 query 不同，
    // 仅监听 path 会漏掉这类切换导致高亮不更新。
    '$route.fullPath': {
      handler() {
        this.findMenu();
      },
      immediate: true,
    },
  },
  created() {
    this.initMenu = new PermissionsTranslation();
    if (this.cmhub) mainBus.$on('cmhub-auth-invalidated', this.refreshFusionMenu);
  },
  beforeDestroy() {
    mainBus.$off('cmhub-auth-invalidated', this.refreshFusionMenu);
  },
  async mounted() {
    mainBus.$on('fold-menu', () => {
      // eslint-disable-next-line no-unused-expressions
      !this.collapsed ? this.menuSwitchOnClick() : null;
    });
    mainBus.$on('expand-menu', () => {
      // eslint-disable-next-line no-unused-expressions
      this.collapsed ? this.menuSwitchOnClick() : null;
    });
    if (isCmhub()) {
      await this.loadFusionMenu();
      return;
    }
    toClearCacheNoReload();
    if (!isCustomerSaasPrivate()) {
      Cookies.remove('zn_env');
      post(api.garyEnv).then((m) => {
        Cookies.set('zn_env', m.env);
      });
      // 初始化阿里云 SLS 埋点
      aliyunDot.initAliyunLog({ http });
    }
    // 获取菜单权限
    post(api.baseMenuList, {
      tenantId: localStorage.getItem('tenantId'),
      appType: 1,
      accountId: localStorage.getItem('accountId'),
    }).then((res) => {
      if (res && res.length > 0) {
        this.menuList = this.initMenu.formattingMenu(res);
        this.menuList.forEach((item) => {
          if (item.children instanceof Array) {
            item.children.forEach((item3) => {
              // eslint-disable-next-line no-param-reassign
              item3.parentMenuCode = item.menuCode;
            });
          }
        });
        this.findMenu();
        localStorage.setItem('menuList', JSON.stringify(this.menuList));
        this.redirectToSubAppHome();
      } else {
        this.menuList = [];
        message.error('您暂无菜单权限，请联系管理员！');
      }
    });
    // 获取按钮权限
    post(api.buttonPermissions, {
      tenantId: localStorage.getItem('tenantId'),
      appType: 1,
      accountId: localStorage.getItem('accountId'),
    }).then((res) => {
      if (res && res.length > 0) {
        localStorage.setItem('elements', JSON.stringify(res));
        mainBus.$emit('elements-exist', true);
      } else {
        // message.error('您暂无按钮权限，请联系管理员！');
      }
    });
    // eslint-disable-next-line eqeqeq
    // if (this.logoUi.appId && this.logoUi.appId == '10011') {
    //   // 根据产品需求，默认跳转客户管理页面
    //   setTimeout(() => {
    //     this.$router.push({
    //       path: '/crm/customerlist',
    //     });
    //   }, 1000);
    // }
    // TODO 如果缓存redirectUrl 存在 进程重定向
    let redirectUrl;
    // eslint-disable-next-line no-unused-expressions
    localStorage.getItem('redirectUrl')
      ? (redirectUrl = JSON.parse(localStorage.getItem('redirectUrl')))
      : (redirectUrl = null);
    if (localStorage.getItem('token')) {
      localStorage.removeItem('redirectUrl');
    }
    if (redirectUrl != null) {
      this.$router.push({
        path: redirectUrl.path,
        query: redirectUrl.params,
      });
    }
  },
  methods: {
    refreshFusionMenu() {
      this.loadFusionMenu(true);
    },
    async loadFusionMenu(force = false) {
      try {
        const result = await loadCmhubResources({ force });
        this.menuList = result.menus;
        this.cmhubError = result.errors.length > 0;
        result.errors.forEach((error) => message.error(error));
        localStorage.setItem('menuList', JSON.stringify(this.menuList));
        this.findMenu();
        if (!this.menuList.length && !this.cmhubError) message.warning('您暂无菜单权限，请联系管理员');
      } catch (error) {
        this.cmhubError = true;
        this.menuList = [];
        message.error(error.message);
      }
    },
    areIcon(k) {
      return !!k.includes('icon-');
    },
    toggleCollapsed(collapsed) {
      this.collapsed = collapsed;
    },
    // 判断菜单的 menuPath 是否匹配当前路由
    // 低码(apaas)页面的 menuPath 带查询串(如 ?objectId=xxx&layoutApiKey=xxx)，
    // 而 $route.path 不含 query，仅用 path 严格相等会匹配失败导致无法高亮，
    // 故优先用 fullPath 全量匹配，再回退 path，最后按 path 一致 + query 子集匹配兼容参数顺序差异。
    isMenuMatch(menuPath) {
      if (!menuPath || menuPath === '-1') return false;
      const { path, fullPath } = this.$route;
      if (menuPath === fullPath || menuPath === path) return true;
      const [menuPathname, menuQuery] = menuPath.split('?');
      if (menuPathname !== path || !menuQuery) return false;
      // menuPath 的每个查询参数都需在当前路由 query 中存在且相等
      const params = new URLSearchParams(menuQuery);
      return Array.from(params.entries())
        .every(([k, v]) => this.$route.query[k] === v);
    },
    // 子工程自带"首页"菜单时，不使用基座自带首页：移除基座首页页签并跳转到子工程首页，
    // 避免页签栏出现两个"首页"。仅在当前停留基座首页(/)且无其它重定向时处理。
    redirectToSubAppHome() {
      if (this.$route.path !== '/') return;
      if (localStorage.getItem('redirectUrl')) return;
      const subHome = getSubAppHomeMenu(this.menuList);
      if (subHome && subHome.menuPath) {
        this.$store.commit('delCurTab', '/');
        this.$router.replace(this.cmhub ? withSide(this.$router, subHome.menuPath, subHome.authSide) : { path: subHome.menuPath });
      }
    },
    findMenu() {
      let curMenu = {};
      let topCode = '';
      // 携带一级祖先 code 递归：top 为空时取自身(即一级)，向下传递保持一级 code 不变，
      // 命中当前路由时记录其所属的一级菜单 code，用于收起态高亮一级图标。
      const fn = (l, top) => {
        l.forEach((k) => {
          const curTop = top || k.menuCode;
          if ((!this.cmhub || k.authSide === this.$route.query[SIDE_QUERY]) && this.isMenuMatch(k.menuPath)) {
            curMenu = k;
            topCode = curTop;
          } else if (k.children && k.children.length) {
            fn(k.children, curTop);
          }
        });
      };

      fn(this.menuList, '');
      this.selectedTopCode = topCode;
      if (curMenu && curMenu.menuCode) {
        this.selectedKey = [`${curMenu.menuCode}`];
        // 收起态：二级菜单默认收起，不展开父级；仅靠 selectedKey 让选中项所属的一级菜单图标高亮
        // （ant 会给父级 submenu 自动加 ant-menu-submenu-selected）。
        // 展开态：自动展开选中项所属的一级菜单。
        if (this.collapsed) {
          this.openKeys = [];
        } else if (this.cmhub && curMenu.ancestorMenuCodes) {
          this.openKeys = curMenu.ancestorMenuCodes;
        } else if (curMenu.parentMenuCode != null) {
          // 注意：系统管理等一级菜单 menuCode 为 ''，其子项 parentMenuCode 也为 ''，
          // 这里用 != null 判断（而非真值判断），保证空 code 的父级也能正确恢复展开
          this.openKeys = [`${curMenu.parentMenuCode}`];
        } else {
          this.openKeys = [];
        }
      } else {
        // this.openKeys = [];
        this.selectedKey = [];
      }
    },
    handleClick(e) {
      const { keyPath = [] } = e || {};
      if (keyPath && keyPath.length) {
        let list = this.menuList;
        let curMenu = {};
        keyPath.reverse().forEach((key) => {
          const obj = list.find((k) => k.menuCode === key);
          if (obj) {
            curMenu = obj;
            list = obj.children;
          }
        });
        if (curMenu.menuPath !== '-1') {
          if (curMenu.menuUrlType === 'ROUTE') {
            if (curMenu.menuPath.includes('znDatavista')) {
              this.openDatavista();
            } else if (
              curMenu.menuPath.includes('znWebUiXn')
              || curMenu.menuPath.includes('znAppUiXn')
            ) {
              // eslint-disable-next-line no-unused-expressions
              curMenu.menuPath.includes('znWebUi')
                ? window.open('https://webui-sit.znlh.work/', '_blank')
                : window.open('https://appui-sit.znlh.work/', '_blank');
            } else if (curMenu.menuPath.includes('znLowCodeAPPDocument')) {
              this.openZnLowCodeAPPDocument();
            } else if (curMenu.menuPath.includes('bigCrmLh')) {
              // 大客CRM：直接在新标签打开 CCRM，不走路由（避免空标签）
              window.open('/ccrm/dashboard', '_blank');
            } else {
              this.$router.push(this.cmhub
                ? withSide(this.$router, curMenu.menuPath, curMenu.authSide)
                : { path: curMenu.menuPath });
            }
          }
          if (curMenu.menuUrlType === 'HTTTP') {
            window.open(curMenu.menuPath, '_blank');
          }
        }
      }
    },
    menuSwitchOnClick() {
      this.collapsed = !this.collapsed;
      if (this.collapsed) {
        // 收起：清空展开项，使二级菜单默认收起，避免残留显示成 "..."
        this.openKeys = [];
      } else {
        // 展开：按当前路由恢复选中项所属一级菜单的展开态
        this.findMenu();
      }
      this.$emit('onClick', this.collapsed);
      // eslint-disable-next-line no-undef
      mainBus.$emit('collapsed-click', this.collapsed);
    },
    openChange(keys) {
      // 受控回写 openKeys：收起态需要它来打开一级菜单右侧的弹出浮层。
      // 注意：收起态必须保持受控且切收起时 openKeys 已清空(见 menuSwitchOnClick/findMenu)，
      // 这样所有一级菜单在收起态恒为 vertical(弹层)模式；否则残留的 open 项会让子菜单停留在
      // inline 模式，hover 时被 antd 切成 vertical 并重建 title 元素，表现为"高亮先消失又恢复"的闪烁。
      const codes = keys.filter((e) => !this.openKeys.some((m) => m === e));
      this.openKeys = keys;
      if (keys.length > 0 && keys[keys.length - 1] !== '') {
        this.openKey = keys[keys.length - 1];
      }
      if (codes.length > 0) {
        this.toPoint(codes[0]);
      }
    },
    toPoint(code) {
      const k = this.menuList.filter((e) => e.code === code);
      let r;
      // eslint-disable-next-line no-unused-expressions
      k.length > 0 ? (r = pointMenus.filter((x) => x.id === k[0].id)) : (r = []);
      if (k.length > 0 && r.length > 0) {
        pointTools.traceClick({
          event_type: 'web_click',
          content: {
            event_id: r[0].event_id || '',
            event_name: k[0].name || '',
          },
        });
      }
    },
    openZnLowCodeAPPDocument() {
      /**
       * 打开外链=> apaas-app端文档
       */
      const token = localStorage.getItem('token');
      // 检查是否存在必要的参数
      if (!token) {
        // 处理缺少参数的异常情况
        message.error('文档缺少必要参数');
        return;
      }
      const znEnv = localStorage.getItem('znEnv');
      const geturl = () => {
        if(znEnv === 'dev') {
          return 'apaas-demo-dev.znlh.work'
        }
        if(znEnv === 'sit') {
          return 'apaas-demo-sit.znlh.work'
        }
        if(znEnv === 'product') {
          return 'apaas-demo.kaigongla.cn'
        }
        return 'apaas-demo.kaigongla.cn'
      }
      const lLinkURL = `https://${geturl()}/hatch/#/home?token=${token}`;
      // 在新的浏览器选项卡或窗口中打开外链
      window.open(lLinkURL, '_blank');
    },
    openDatavista() {
      /**
       * 打开外链=>数据大屏中转页处理参数=>目标页面
       */
      const token = localStorage.getItem('token');
      const appId = localStorage.getItem('appId');
      const znEnv = localStorage.getItem('znEnv');
      // const curEnv = localStorage.getItem('curEnv');

      // 检查是否存在必要的参数
      if (!token || !appId || !znEnv) {
        // 处理缺少参数的异常情况
        message.error('数据大屏缺少必要参数');
        return;
      }

      const externalLinkURL = `https://datavista.kaigongla.cn/lad?token=${token}&appId=${appId}&znEnv=${znEnv}`;
      // const externalLinkURL = `http://192.168.220.177:4000/lad?token=${token}&appId=${appId}&znEnv=${znEnv}`;
      // 在新的浏览器选项卡或窗口中打开外链
      window.open(externalLinkURL, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.oms-menu {
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  user-select: none;

  .oms-menu-header {
    width: 100%;
    min-height: 60px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    // .logo { width: 150px; }
  }

  .ant-menu-dark {
    background: #333333;
  }
  //::v-deep .ant-menu-submenu-title {
  //  text-align: center;
  //  padding: 0!important;
  //}
  //::v-deep .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title{
  //  text-align: center;
  //  padding: 0!important;
  //}
  //::v-deep .ant-menu-item{
  //  text-align: center;
  //  padding: 0!important;
  //}
  .oms-menu-content {
    flex: 1;
    overflow-x: hidden;
    overflow-y: scroll;

    ::v-deep .ant-menu-dark .ant-menu-inline.ant-menu-sub {
      background: #2B3C62;
      box-shadow: none;
    }

    // 默认菜单文字颜色
    ::v-deep .ant-menu-dark,
    ::v-deep .ant-menu-dark .ant-menu-item,
    ::v-deep .ant-menu-dark .ant-menu-item > a,
    ::v-deep .ant-menu-dark .ant-menu-submenu-title {
      color: var(--navigationTextColor);
    }

    // 菜单项左右间距、圆角（非展开父级）
    ::v-deep .ant-menu-item,
    ::v-deep .ant-menu-submenu:not(.ant-menu-submenu-open) > .ant-menu-submenu-title {
      width: calc(100% - var(--menuItemGap) * 2) !important;
      margin-left: var(--menuItemGap) !important;
      margin-right: var(--menuItemGap) !important;
      border-radius: var(--menuItemRadius);
    }

    // 展开的父级组：整组加圆角容器
    // 注意：限定在 .ant-menu-inline(展开态)下。收起态 hover 一级菜单会打开弹层并给 LI 加
    // .ant-menu-submenu-open，若不限定，这些"展开父级组"样式会在收起态 hover 时生效，
    // 导致 LI 加 margin/overflow、title 变成撑满的长方形背景，图标看起来向下沉、背景也非正方形。
    ::v-deep .ant-menu-inline.ant-menu-dark .ant-menu-submenu-open {
      margin: 4px var(--menuItemGap) !important;
      border-radius: var(--menuItemRadius);
      overflow: hidden;
    }

    // 展开时父级 title 撑满容器，背景与子菜单区域一致（同样仅限展开态）
    ::v-deep .ant-menu-inline.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title {
      width: 100% !important;
      margin: 0 !important;
      border-radius: 0 !important;
      color: #fff !important;
      background: #2B3C62 !important;
    }

    // 选中态蓝色背景（优先级最高）
    ::v-deep .ant-menu-dark .ant-menu-item-selected {
      background-color: var(--themeColor) !important;
    }

    // 选中项文字保持白色
    ::v-deep .ant-menu-dark .ant-menu-item-selected,
    ::v-deep .ant-menu-dark .ant-menu-item-selected > a {
      color: #fff;
    }

    // ::v-deep .ant-menu-dark .ant-menu-item:hover {
    //   background: #52688f;
    // }

    ::v-deep .ant-menu-sub.ant-menu-inline > .ant-menu-item,
    ::v-deep .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title,
    ::v-deep .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
      height: 40px;
      line-height: 40px;

      .anticon + span {
        margin-left: 0 !important;
      }
    }
    ::v-deep .ant-menu-inline > .two-menu > .ant-menu-submenu-title {
      padding-left:0px !important;
    }

    // 子菜单项之间有间距
    ::v-deep .ant-menu-inline .ant-menu-item:not(:last-child) {
      margin-bottom: 4px;
    }

    ::v-deep .ant-menu-inline .ant-menu-submenu-title,
    ::v-deep .ant-menu-inline .ant-menu-item {
      margin-top: 4px;
      margin-bottom: 4px;
    }

    // 子菜单项默认透明
    ::v-deep .ant-menu-sub.ant-menu-inline > .ant-menu-item {
      background: transparent;
    }

    // hover 浅色圆弧（非选中项），选中项 hover 保持蓝色
    ::v-deep .ant-menu-dark .ant-menu-sub .ant-menu-item:not(.ant-menu-item-selected):hover {
      background: #33476F !important;
      color: #fff;
    }

    // 有子级的一级菜单（未展开）标题 hover 背景色，与无子级一级菜单保持一致。
    // 必须排除选中项(.oms-top-collapsed-selected / antd 的 .ant-menu-submenu-selected)：
    // 收起态 hover 选中项时，会有"已 hover 但弹层尚未 open"的一帧，此时该规则(:not(open) + :hover)
    // 会以更高优先级把选中项背景刷成 #33476F，下一帧 open 后又变回 themeColor，表现为高亮闪一下。
    ::v-deep .ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-open):not(.oms-top-collapsed-selected):not(.ant-menu-submenu-selected) > .ant-menu-submenu-title:hover {
      background: #33476F !important;
      color: #fff;
    }

    // 去除 ant 菜单项默认过渡，避免展开/收起一级菜单时二级文字向左下角抖动：
    // 1) 菜单项/标题本身的 padding 0.15s 过渡（横向）
    // 2) 图标 .anticon 的 margin 0.3s 过渡（横向，会带动其后文字）
    // 3) 文字 span(.anticon + span) 的 width 0.3s 过渡（横向）
    // 仅保留颜色/背景过渡；展开动画由父级 ul 的 height 负责，不涉及子项位移。
    ::v-deep .ant-menu-item,
    ::v-deep .ant-menu-submenu-title,
    ::v-deep .ant-menu-item .anticon,
    ::v-deep .ant-menu-submenu-title .anticon,
    ::v-deep .ant-menu-item .anticon + span,
    ::v-deep .ant-menu-submenu-title .anticon + span {
      transition: color 0.3s, background 0.3s, border-color 0.3s !important;
    }

    // 钉死二/三级菜单项的左内边距：ant-design-vue(vc-menu) 会给每个 inline 菜单项
    // 内联写入 padding-left = inlineIndent(24) * level（二级=48px、三级=72px），
    // 与模板里硬编码的 22px/45px 冲突，展开一级菜单瞬间会从 48px 跳到 22px，
    // 表现为二级文字向左抖动。用 !important 覆盖内联值，使其始终为目标值，消除抖动。
    ::v-deep .ant-menu-sub.ant-menu-inline > .ant-menu-item {
      padding-left: 22px !important;
    }
    // 三级菜单项（嵌套在 .two-menu 下）保持 45px
    ::v-deep .two-menu .ant-menu-sub.ant-menu-inline > .ant-menu-item {
      padding-left: 45px !important;
    }

    /* ===== 收起(简约)态：图标按钮统一为正方形，常规态 / hover / 选中态同尺寸，消除抖动 =====
       原因：上面的 .ant-menu-item / .ant-menu-submenu(:not open) > title 规则会给收起态菜单项写入
       width: calc(100% - 10px)(约 70px) 且左右 margin 5px，导致图标框是「宽 70 高 50」的长方形，
       长宽不一致；同时 hover 背景铺满该长方形，与常规态视觉尺寸不同，鼠标移入会有轻微抖动。
       这里用同等/更高优先级的收起态专用规则，将一级带子菜单(submenu-title)与无子菜单(menu-item)
       统一钉成 50x50 正方形并水平居中；常规、hover、选中三态尺寸完全一致，故不再抖动，背景也是正方形。 */
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-item,
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
      width: 50px !important;
      height: 50px !important;
      line-height: 50px !important;
      padding: 0 !important;
      margin: 4px auto !important;
      border-radius: 12px !important;
      // 用 flex 把图标钉在正方形正中，不依赖 line-height（标题内是 div 块级结构，
      // line-height 无法居中块级内容，常规态图标会靠上，hover 出现背景后视觉上像"下沉"）。
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      // 仅保留背景色过渡，去掉可能引起位移的 height/padding/margin 过渡，杜绝抖动。
      transition: background-color 0.2s !important;
    }
    // 标题内层包裹 div / .iconBg 归零，保证图标严格居中，不引入纵向偏移
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title > div,
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title > div > div,
    ::v-deep .ant-menu-inline-collapsed .iconBg {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 1 !important;
      height: auto !important;
    }
    // 收起态隐藏菜单文字，避免占位/换行把图标顶偏
    ::v-deep .ant-menu-inline-collapsed .ant-menu-item > span,
    ::v-deep .ant-menu-inline-collapsed .iconBg > span {
      display: none !important;
    }
    // 图标本体不留外边距、垂直居中
    ::v-deep .ant-menu-inline-collapsed .anticon {
      margin: 0 !important;
      line-height: 1 !important;
      vertical-align: middle !important;
    }
    // 收起态 hover 背景（非高亮）：鼠标移上 / 弹层打开时，图标框显示较浅的深蓝方形背景，
    // 与原设计一致（原先来自 .ant-menu-submenu-open>title 的 #2B3C62，随展开父级组规则限定被移除，
    // 这里显式补回）。排除已选中项，保证选中项 hover 时仍是主题高亮色、不被 hover 色盖掉。
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-item:not(.ant-menu-item-selected):hover,
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.oms-top-collapsed-selected) > .ant-menu-submenu-title:hover,
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-submenu-open:not(.ant-menu-submenu-selected):not(.oms-top-collapsed-selected) > .ant-menu-submenu-title {
      background-color: #2B3C62 !important;
      color: #fff !important;
    }
    // 收起态点击/选中：themeColor 方形高亮。显式覆盖所有交互态(:hover / -active / -open)，
    // 并关闭背景过渡，防止选中项 hover 时背景先过渡到别的色再回来、出现"暗一下"的闪烁。
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-item-selected,
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-item-selected:hover,
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-submenu-selected > .ant-menu-submenu-title,
    ::v-deep .ant-menu-inline-collapsed > .ant-menu-submenu-selected > .ant-menu-submenu-title:hover,
    ::v-deep .ant-menu-inline-collapsed > .oms-top-collapsed-selected > .ant-menu-submenu-title,
    ::v-deep .ant-menu-inline-collapsed > .oms-top-collapsed-selected > .ant-menu-submenu-title:hover,
    ::v-deep .ant-menu-inline-collapsed > .oms-top-collapsed-selected.ant-menu-submenu-open > .ant-menu-submenu-title,
    ::v-deep .ant-menu-inline-collapsed > .oms-top-collapsed-selected.ant-menu-submenu-active > .ant-menu-submenu-title {
      background-color: var(--themeColor) !important;
      color: #fff !important;
      opacity: 1 !important;
      transition: none !important;
    }
    // 收起态：彻底关闭整个收起菜单(含 ul 及其所有后代)的过渡动画。
    // "暗一下"是过渡/动画造成的瞬时闪烁：hover 打开弹层时，真正发生背景/颜色过渡的往往是
    // <li>(.ant-menu-item / .ant-menu-submenu) 或图标等后代元素，仅给 title 关过渡不够。
    // 收起态无需任何展开动画，这里整棵子树关闭 transition，从根上杜绝一切 hover 闪烁。
    // 用 .ant-menu.ant-menu-inline-collapsed 双类提高优先级，压过后面非 scoped 的
    // `.oms-menu .ant-menu *` 全局过渡规则（同为 !important，仅靠单类会因源码靠后而失效）。
    ::v-deep .ant-menu.ant-menu-inline-collapsed,
    ::v-deep .ant-menu.ant-menu-inline-collapsed * {
      transition: none !important;
    }
  }

  // 收起态一级图标框统一由上方 50x50 正方形规则控制，这里不再写入横向 padding，
  // 避免与正方形规则冲突（保留仅作占位/兜底，padding 归零）。
  ::v-deep  .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
    height: 50px;
    padding: 0 !important;
  }

  ::v-deep  .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  .ant-menu-submenu-active,
  .ant-menu-submenu-title:hover {
    color: white;
  }

  .oms-menu-content {
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected):hover {
  background: #33476F !important;
}
.ant-menu-dark .ant-menu-item.ant-menu-item-selected:hover {
  background: var(--themeColor) !important;
}

.menu-switch {
  height: 33px;
  background-color: var(--navigationBackColor);
  display: flex;
  justify-content: flex-end;
  align-items: center;

  img {
    margin-right: 16px;
  }

  .menu-switch-icon {
    margin-right: 16px;
    color: var(--navigationTextColor);
    font-size: 16px;
  }
}

.menuUnfold {
  justify-content: flex-end;

  img {
    margin-right: 16px;
  }
}

.menuFold {
  justify-content: center;

  img,
  .menu-switch-icon {
    margin-right: 0;
  }
}
</style>
<style lang="less" >
/* ===== 修复：展开/收起一级菜单时二级文字向左抖动 =====
   ant-design-vue(vc-menu) 给每个 inline 菜单项内联写入 padding-left = inlineIndent(24)*level
   （二级=48px、三级=72px），与设计稿的 22px/45px 冲突，展开瞬间从 48px 过渡/落到 22px，
   表现为二级文字向左滑动。此处用非 scoped 的全局规则(限定在 .oms-menu 内)钉死左内边距，
   确保始终生效（避免 ::v-deep 作用域/优先级边界问题），并去掉相关过渡。 */
.oms-menu {
  // 二级项：左内边距(文字缩进)22px；背景区域左右各离菜单边 10px。
  // 这里的 margin 10px 是"收起动画那一刻"的值(此时展开组已无横向 margin)，
  // 与下方展开态的 5px(叠加展开组 5px=10px) 配合，保证两态恒为 10px、不抖动。
  .ant-menu-sub.ant-menu-inline > .ant-menu-item {
    padding-left: 22px !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
    width: calc(100% - 20px) !important;
  }
  // 三级菜单项（嵌套在 .two-menu 下）保持 45px
  .two-menu .ant-menu-sub.ant-menu-inline > .ant-menu-item {
    padding-left: 45px !important;
  }
  // 菜单内所有元素仅允许 颜色/背景/边框 以及 height/opacity(用于展开收起的高度动画) 过渡，
  // 移除 margin/padding/width/transform 等一切会造成横向位移的过渡，
  // 从根上消除展开/收起一级菜单时二级文字向左抖动（白名单方式，避免逐个属性排查遗漏）。
  .ant-menu,
  .ant-menu * {
    transition: color 0.3s, background-color 0.3s, border-color 0.3s, opacity 0.15s, height 0.15s !important;
  }

  // 一级/二级/三级菜单文字统一不加粗（代码无显式 font-weight，加粗来自继承/字体，故强制 400）
  .ant-menu-item,
  .ant-menu-submenu-title,
  .ant-menu-item span,
  .ant-menu-submenu-title span,
  .iconBg,
  .iconBg span {
    font-weight: 400 !important;
  }

  // 展开态：父级组(.ant-menu-submenu-open) LI 带 margin:4px 5px(左右各 5px)，
  // 二级项再各取 5px → 背景区域离菜单边恒为 10px，且左右对称。
  // 收起动画那一刻 open 类被移除，二级项回落到上面的基础规则(margin 10px、组 margin 0)，
  // 同样是 10px，故展开/收起两态偏移一致，不会横向抖动。
  .ant-menu-submenu-open > .ant-menu-sub > .ant-menu-item {
    margin-left: 5px !important;
    margin-right: 5px !important;
    width: calc(100% - 10px) !important;
  }
}

/* 菜单折叠后样式优化 Start */
.collapsedIconBg {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 0;
}

.ant-menu-submenu.ant-menu-submenu-vertical .ant-menu-submenu-title {
  padding: 0 !important;
  text-align: center;
  width: 50px;
  height: 50px;
  line-height: 50px !important;
  margin: 0 auto;
  border-radius: 16px;
}

.ant-menu-submenu.ant-menu-submenu-vertical .ant-menu-submenu-title:hover {
  background: var(--themeColor);
}

.ant-menu-submenu.ant-menu-submenu-vertical.ant-menu-submenu-selected .ant-menu-submenu-title {
  background: var(--themeColor);
}

/* 收起态：当前页所属的一级菜单图标高亮。
   不依赖 ant 的 ant-menu-submenu-selected 自动类（inline-collapsed 下子项进弹层，该类常不生效），
   改由 selectedTopCode 显式控制，确保一级图标稳定高亮。 */
.ant-menu-submenu.oms-top-collapsed-selected > .ant-menu-submenu-title,
.ant-menu-submenu.oms-top-collapsed-selected > .ant-menu-submenu-title:hover {
  background: var(--themeColor) !important;
  color: #fff !important;
  // 关键：选中项恒高亮且不做背景过渡，避免 hover 时背景先过渡到 antd 的透明/中间色再回来，
  // 表现为"先取消高亮又恢复高亮"的闪烁。
  transition: none !important;
}

.ant-menu-submenu.ant-menu-submenu-vertical.ant-menu-submenu-open .ant-menu-submenu-title {
  background: var(--themeColor) !important;
  color: #fff !important;
  transition: none !important;
}

// 整体背景
.ant-menu-dark .ant-menu.ant-menu-vertical.ant-menu-sub {
  width: 232px;
  background: #3e5175;
  padding: 8px 0;
  border-radius: 8px;
}

// 缩小菜单背景
::v-deep .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item {
  height: 50px;
  line-height: 50px;
  background-color: var(--themeColor) !important;
  margin: 0 !important;
}

.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  background: var(--themeColor);
}

.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-active {
  background: var(--themeColor);
}

.ant-menu-dark.ant-menu-submenu-popup {
  left: 84px !important;
}

/* 菜单折叠后样式优化 End */
</style>
